import React from 'react';

const HorizontalSidebar = () => {
	return <div></div>;
};

export default HorizontalSidebar;
